export default "__VITE_ASSET__25bIxORl__"